import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../constants/svgIcon';
import { SvgIcon } from '../../Molecules';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './ReportSummaryPopup.module.css';

export enum SummaryType {
  GameScore = 'GameScore',
  GamePlayed = 'GamePlayed',
  TimePlayed = 'TimePlayed',
}

interface SummaryConfig {
  textList: string[];
  icon: SVGIconType;
  title: string;
}

const summaryConfigs: Record<SummaryType, SummaryConfig> = {
  [SummaryType.GameScore]: {
    textList: [
      'The Average Score is the average of all Memory Practice performance.',
      'If practice are removed, the average performance will be recalculated.',
    ],
    icon: SVGIconType.DoubleScore,
    title: 'Average Score: ',
  },
  [SummaryType.GamePlayed]: {
    textList: [
      'The Practice Completed is the number of all Memory Practice played.',
    ],
    icon: SVGIconType.PracticeTick,
    title: 'Practice Completed: ',
  },
  [SummaryType.TimePlayed]: {
    textList: [
      'The Time Spend is the amount of time spent in playing Memory Practice.',
    ],
    icon: SVGIconType.DoubleClock,
    title: 'Time Spend: ',
  },
};

type ReportSummaryPopupProps = {
  summaryType: SummaryType;
  value: string | number;
  onPressPlay: () => void;
  onPressCancel: () => void;
};

export const ReportSummaryPopup = (props: ReportSummaryPopupProps) => {
  const { summaryType, value, onPressPlay, onPressCancel } = props;
  const { t } = useTranslation();
  const summaryConfig = summaryConfigs[summaryType];
  return (
    <BasicPopupContainer
      onPrimaryButtonClick={onPressPlay}
      primaryButtonLabel={t('Play')}
      onSecondaryButtonClick={onPressCancel}
      secondaryButtonLabel={t('OK')}
    >
      <div className={styles.container}>
        <div className={styles.iconContainer}>
          <SvgIcon
            name={summaryConfig.icon}
            color={'#333'}
            width={'100%'}
            height={'100%'}
          />
        </div>
        <div className={styles.titleContainer}>
          <p className={styles.title}>
            {t(summaryConfig.title)}
            {value}
          </p>
        </div>
        <div className={styles.contentContainer}>
          {summaryConfig.textList.map((text, index) => (
            <div key={index} className={styles.text}>
              {t(text)}
            </div>
          ))}
        </div>
      </div>
    </BasicPopupContainer>
  );
};
